var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgEstimatePhotos(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 30 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9 3.75a.75.75 0 00-.75.75V15c0 .414.336.75.75.75h2.348v-4.39l-.028.018a.917.917 0 01-1.193-.246l-.059-.09a.917.917 0 01.246-1.193l.09-.059 6.35-3.667a.912.912 0 01.485-.122.916.916 0 01.498.122l3.666 2.116 1.828 1.056.857.495a.917.917 0 01-.822 1.635v4.325H25.5a.75.75 0 00.75-.75V4.5a.75.75 0 00-.75-.75H9zM7.5 1.5A1.5 1.5 0 006 3v13.5A1.5 1.5 0 007.5 18H27a1.5 1.5 0 001.5-1.5V3A1.5 1.5 0 0027 1.5H7.5zM6 20.25h17.905A3.001 3.001 0 0121 22.5H4.5a3 3 0 01-3-3v-12c0-1.398.956-2.572 2.25-2.905V18c0 1.5.75 2.25 2.25 2.25z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgEstimatePhotos);
export default ForwardRef;
